import React from 'react';

interface GraduationCapOutlineIconProps {
  size?: number;
  color?: string;
}

const GraduationCapOutlineIcon: React.FC<GraduationCapOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66675 7.5L10.0001 3.33334L18.3334 7.5L10.0001 11.6667L1.66675 7.5Z"
        stroke={color}
        strokeWidth="1.425"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9.16669V13.3334C5 13.9964 5.52678 14.6323 6.46447 15.1011C7.40215 15.5699 8.67392 15.8334 10 15.8334C11.3261 15.8334 12.5979 15.5699 13.5355 15.1011C14.4732 14.6323 15 13.9964 15 13.3334V9.16669"
        stroke={color}
        strokeWidth="1.425"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 7.5V12.0833"
        stroke={color}
        strokeWidth="1.425"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GraduationCapOutlineIcon;
